function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "email-outline-alerted",
  transform: "translate(-1.999 0.1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Union_160",
  "data-name": "Union 160",
  d: "M2.33,35.057A2.33,2.33,0,0,1,0,32.728V9.435A2.33,2.33,0,0,1,2.33,7.1H22.374l-1.338,2.33H3.855L18.449,23.958l6.1-6.068h3.3L20.09,25.611a2.326,2.326,0,0,1-3.283,0L2.33,11.205V31.378l8.41-8.7,1.676,1.62L4.263,32.728H33.148L24.727,24.3l1.643-1.643,8.572,8.573V19.054L36.9,17.889l.372-.023V32.728a2.329,2.329,0,0,1-2.328,2.33ZM23.844,8.21a8.211,8.211,0,1,1,8.213,8.212A8.211,8.211,0,0,1,23.844,8.21Zm4.463-.671A.767.767,0,0,0,28.283,8.6L31,11.321a.77.77,0,0,0,1.107-.02l4.1-5.124a.77.77,0,0,0-.01-1.078l0,0a.771.771,0,0,0-1.109.022L31.519,9.666l-2.148-2.15a.77.77,0,0,0-1.064.023Z",
  transform: "translate(2 -0.1)",
  fill: "#8b8c8e"
}));

function SvgSendinvite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.268,
    height: 35.058,
    viewBox: "0 0 40.268 35.058",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendinvite);
export default __webpack_public_path__ + "static/media/sendinvite.c1d3ed67.svg";
export { ForwardRef as ReactComponent };